import React from 'react';

const LiveProjectsSection = ({
  accentColor = '#16A34A',
  accentBg   = '#F0FDF4',
  accentBorder = '#BBF7D0',
  title    = 'Live Project Experience',
  features = [],
  projects = [],
}) => (
  <section style={{ padding:'64px 5%', background: accentBg, borderTop:`1px solid ${accentBorder}` }}>
    <style>{`
      .lps-body    { display:grid; grid-template-columns:1fr 1.4fr; gap:48px; align-items:center; }
      .lps-projects{ display:grid; grid-template-columns:1fr 1fr; gap:12px; }
      @media(max-width:900px){ .lps-body { grid-template-columns:1fr; } }
      @media(max-width:560px){ .lps-projects { grid-template-columns:1fr; } }
    `}</style>

    <div style={{ maxWidth:1200, margin:'0 auto' }}>

      {/* ── Header ── */}
      <div style={{ marginBottom:40, textAlign:'center' }}>
        <h2 style={{ fontSize:24, fontWeight:900, color:accentColor, margin:0, letterSpacing:'-0.01em' }}>
          {title}
        </h2>
      </div>

      <div className="lps-body">

        {/* ── Left: checklist + laptop ── */}
        <div>
          <div style={{ display:'flex', flexDirection:'column', gap:13, marginBottom:32 }}>
            {features.map(f => (
              <div key={f} style={{ display:'flex', alignItems:'center', gap:10, fontSize:13.5, color:'#1E293B', fontWeight:600 }}>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" style={{ flexShrink:0 }}>
                  <circle cx="12" cy="12" r="11" fill={accentColor+'22'} stroke={accentColor} strokeWidth="1.5"/>
                  <polyline points="7 12 10 15 17 9" stroke={accentColor} strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                {f}
              </div>
            ))}
          </div>

        </div>

        {/* ── Right: project cards ── */}
        <div>
          <div className="lps-projects">
            {projects.slice(0, 6).map(p => (
              <div key={p.name} style={{ background:'#fff', border:`1.5px solid ${accentBorder}`, borderRadius:12, padding:'14px 16px', display:'flex', alignItems:'center', gap:12, transition:'box-shadow 0.2s' }}>
                <div style={{ width:44, height:44, borderRadius:10, background:accentBg, border:`1.5px solid ${accentBorder}`, display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0, fontSize:22 }}>
                  {p.icon}
                </div>
                <span style={{ fontSize:13, fontWeight:700, color:'#1E293B', lineHeight:1.35 }}>{p.name}</span>
              </div>
            ))}
          </div>
        </div>

      </div>
    </div>
  </section>
);

export default LiveProjectsSection;
